const initialState = {
  agentProfitRanges: [],
  totalCount: 0,
  loading: false,
  error: null,
};

export const agentProfitRangeReducer = (state = initialState, action) => {
  switch (action.type) {
    case "AGENT_PROFIT_RANGE_LIST_REQUEST":
      return { ...state, loading: true, error: null };

    case "AGENT_PROFIT_RANGE_LIST_SUCCESS":
      return {
        ...state,
        loading: false,
        agentProfitRanges: action.payload.data || [],
        totalCount: action.payload.total || 0,
      };

    case "AGENT_PROFIT_RANGE_LIST_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "AGENT_PROFIT_RANGE_ADD_REQUEST":
      return { ...state, loading: true, error: null };

    case "AGENT_PROFIT_RANGE_ADD_SUCCESS":
      return {
        ...state,
        loading: false,
        agentProfitRanges: [...state.agentProfitRanges, action.payload.data],
        error: null,
      };

    case "AGENT_PROFIT_RANGE_ADD_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "AGENT_PROFIT_RANGE_UPDATE_REQUEST":
      return { ...state, loading: true, error: null };

    case "AGENT_PROFIT_RANGE_UPDATE_SUCCESS":
      return {
        ...state,
        loading: false,
        agentProfitRanges: state.agentProfitRanges.map(item =>
          item._id === action.payload.data._id ? action.payload.data : item
        ),
        error: null,
      };

    case "AGENT_PROFIT_RANGE_UPDATE_FAIL":
      return { ...state, loading: false, error: action.payload };

    case "AGENT_PROFIT_RANGE_REMOVE_REQUEST":
      return { ...state, loading: true, error: null };

    case "AGENT_PROFIT_RANGE_REMOVE_SUCCESS":
      return {
        ...state,
        loading: false,
        agentProfitRanges: state.agentProfitRanges.filter(item => item._id !== action.payload.data._id),
        error: null,
      };

    case "AGENT_PROFIT_RANGE_REMOVE_FAIL":
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
